import { LocalizedType } from './common';
import { UserData } from './user';

export type Topic = LocalizedType & {
  id: number;
  order: number;
  quizzesCount: number;
  userData?: UserData | null;
  topicType: TopicTypes;
  activitiesInTopic?: number;
};

export enum TopicTypes {
  EndOfSkillTest = 3,
}
